import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ServicesSection from './ServicesSection';
import ContactSection from './ContactSection';
import NewFooter from '../../common/NewFooter';
import ContactWidget from '../../ui/ContactWidget';
import GoogleReviews from '../../common/GoogleReviews';
import GlobalStyle from '../../style/Global/GlobalStyle.jsx';
import typography from '../../../utils/typography';

// Import a background image (replace with your actual image path)
import heroBgImage from '../../../assets/images/pages/Research/About.jpg';
import SEO from '../../common/SEO';

const Index = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [, setIsVisible] = useState({});




  const schemaData = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Thesis writing and research paper publication services",
      "provider": { "@id": "https://aegresearch.in/#organization" },
      "areaServed": { "@type": "City", "name": "Bhopal" },
      "description": "Best thesis writing services in Bhopal - thesis writing, paper writing, SCI research paper guidance, research paper publication, SCI paper publication and Scopus paper publication by Assurance Education Group.",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Academic Research Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Thesis Writing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Paper Writing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SCI Research Paper Guidance" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Research Paper Publication" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SCI Paper Publication" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Scopus Paper Publication" } }
        ]
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://aegresearch.in/#website",
      "url": "https://aegresearch.in/",
      "name": "ResearchLens - Assurance Education Group",
      "publisher": { "@id": "https://aegresearch.in/#organization" },
      "inLanguage": "en-IN"
    }
  ];

 const services = [
  {
    id: 1,
    title: 'Thesis Development',
  description: 'Comprehensive thesis guidance from topic selection and methodology to analysis, structured writing, editing, and final defense.',
  icon: 'BookOpen',
    rating: 4.9,
    features: [
      'Topic Selection & Proposal',
      'Research Methodology Design',
      'Data Collection & Analysis',
      'Thesis Writing & Editing',
      'Presentation & Viva Support',
    ],
    path: '/thesis-home',
    buttonText: 'Research Lens',
    gradient: 'from-indigo-500 to-purple-500',
    hoverGradient: 'from-indigo-500 to-purple-600',
  },
  {
    id: 2,
    title: 'Conference & Events',
    description: 'End-to-end management of academic conferences, seminars, and technical events with seamless coordination, global participation, and advanced digital integration.',

    icon: 'Users',
    rating: 4.8,
    features: [
      'Smart Event Planning',
      'Virtual & Physical Conferences',
      'Global Participation',
      'Live Streaming',
    ],
    path: '/conference-home',
    buttonText: 'AEG Research Solutions',
    gradient: 'from-indigo-500 to-purple-500',
    hoverGradient: 'from-indigo-500 to-purple-500',
  },
  {
    id: 3,
    title: 'Research & Development',
    description:
      'At AEG Consultancy Services Pvt. Ltd., we focus on exploring new ideas and improving software technologies to create smarter and more reliable solutions for everyday use.',
    icon: 'FlaskConical',
    rating: 4.7,
    features: [
      'Innovative Software Projects',
      'Improving App Performance',
      'User-Friendly Designs',
      'Continuous Testing & Feedback',
    ],
    path: '/research-home',
    buttonText: 'AEG Consultancy Services',
    gradient: 'from-indigo-500 to-purple-500',
    hoverGradient: 'from-indigo-500 to-purple-500',
  },
];

  useEffect(() => {
    const handleMouseMove = e => {
      setMousePosition({
        x: (e.clientX - window.innerWidth / 2) / 50,
        y: (e.clientY - window.innerHeight / 2) / 50,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries =>
        entries.forEach(entry =>
          setIsVisible(prev => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting,
          }))
        ),
      { threshold: 0.1 }
    );
    document
      .querySelectorAll('[data-animate]')
      .forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className='min-h-screen overflow-hidden relative bg-gradient-to-br from-orange-100 via-orange-50 to-orange-100 font-sans'>
      <SEO 
        title="Best Thesis Writing Services in Bhopal | PhD & MTech Thesis Help"
        description="Assurance Education Group provides the best thesis writing services in Bhopal, MTech & PhD thesis writing, Scientific Research, research paper writing & publication, SCI & Scopus paper writing, and plagiarism check."
        keywords={[
          "best thesis writing services in bhopal",
          "Scientific Research",
          "Mtech Thesis Writing",
          "Research paper writing and publication",
          "PhD Thesis writing service and help",
          "Research Paper design and publication",
          "Paper Writing Bhopal",
          "Plagiarism Check Bhopal",
          "Review paper writing bhopal",
          "IEEE paper writing",
          "Scopus paper writing bhopal",
          "SCI paper writing bhopal",
          "Conference paper writing publication"
        ]}
        canonicalPath="/"
        schemaData={schemaData}
      />

      {/* Animated Background */}
      <div className='fixed inset-0 overflow-hidden pointer-events-none'>
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className='absolute rounded-full opacity-20 animate-float'
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 100 + 50}px`,
              height: `${Math.random() * 100 + 50}px`,
              background: `linear-gradient(45deg, ${['#3B82F6', '#06B6D4', '#10B981', '#F59E0B', '#EF4444'][Math.floor(Math.random() * 5)]}40, transparent)`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${Math.random() * 20 + 15}s`,
            }}
          ></div>
        ))}
        <div
          className='absolute inset-0 opacity-5'
          style={{
            backgroundImage: `linear-gradient(to right, #3B82F6 1px, transparent 1px), linear-gradient(to bottom, #3B82F6 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
          }}
        ></div>
      </div>

      {/* Hero Section with Background Image */}
      <div 
        className="relative py-16 md:py-24 mb-4 md:mb-6"
        style={{
          backgroundImage: `url(${heroBgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black opacity-30"></div>
        
        <div className="relative z-10 text-center max-w-6xl mx-auto px-4">
          <motion.h1
            className={`${typography.heading1} text-white mb-4`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="block mb-2">AEG Group &ndash; Best Thesis Writing Services in Bhopal</span>
            <span className='bg-gradient-to-r from-purple-400 to-blue-400  bg-clip-text text-transparent'>
              Thesis Writing, Paper Writing &amp; Research Paper Publication
            </span>
          </motion.h1>
          <p
            className={`${typography.subtitle} text-white max-w-2xl mx-auto bg-black bg-opacity-40 p-4 rounded-lg backdrop-blur-sm`}
          >
            Assurance Education Group (ResearchLens / aegresearch) provides the best thesis writing
            services in Bhopal &mdash; thesis writing, paper writing, SCI research paper guidance,
            research paper publication, SCI paper publication and Scopus paper publication &mdash;
            alongside academic conference management and research &amp; development. Call +91 6268558700.
          </p>
        </div>
      </div>

      {/* <HeroCarousel videos={videos} typography={typography} /> */}
      <ServicesSection services={services}  typography={typography}/>
      <GoogleReviews />
      <ContactSection typography={typography} />
      <ContactWidget />
      <NewFooter />
      <GlobalStyle />
    </div>
  );
};

export default Index;